app.directive('regulationTextItem', ['$rootScope', 'utilsService', function ($rootScope, utilsService) {
    return {
        restrict: "E",
        replace: true,
        templateUrl: "/templates/partials/directives/regulation-text-item.html",
        link: function () {
        }
    }
}])